import PropTypes from 'prop-types'
import clsx from 'clsx'

import Foundation from './Foundation'

import Header from '~partials/header'
import Footer from '~partials/footer'
import AnnouncementBar from '~partials/AnnouncementBar'

const BaseLayout = ({
  children,
  noHeader,
  noFooter,
  siteWrapperProps,
  headerProps,
  footerProps,
}) => (
  <Foundation>
    {!headerProps?.hideAnnouncementBar && <AnnouncementBar />}

    <div
      className={clsx({
        'has-stickyHeader':
          typeof headerProps?.sticky !== 'boolean' && !headerProps?.sticky, // This checks to see if we're explicitly not setting the sticky header (enabled by default) for `scroll-margin-top` functionality
      })}
      css={{ position: 'relative' }}
      {...siteWrapperProps}
    >
      {!noHeader && <Header {...headerProps} />}
      {children}
      {!noFooter && <Footer {...footerProps} />}
    </div>
  </Foundation>
)

BaseLayout.propTypes = {
  children: PropTypes.node.isRequired,
  noHeader: PropTypes.bool,
  noFooter: PropTypes.bool,
  headerProps: PropTypes.shape({
    contrast: PropTypes.bool,
    hasDefaultOverlay: PropTypes.bool,
    forceCTAContrast: PropTypes.bool,
    sticky: PropTypes.bool,
    showNav: PropTypes.bool,
    showPrimaryLogo: PropTypes.bool,
    hideAnnouncementBar: PropTypes.bool,
    logoAside: PropTypes.any,
  }),
  footerProps: PropTypes.shape({
    hideCTA: PropTypes.bool,
  }),
  siteWrapperProps: PropTypes.object,
}

export default BaseLayout
